export async function getBlobFromBase64String(base64String) {
    const res = await fetch(base64String)
    return await res.blob()
}

export async function convertSignatureTextToImageString(text, configData: any = {}) {
    const myFont = new FontFace("AlexBrush", "url(/fonts/AlexBrush-Regular.woff)")
    const font = await myFont.load()
    document.fonts.add(font)

    const textCanvas = document.createElement("canvas")
    const ctx = textCanvas.getContext("2d")
    const defaultFontSize = configData?.fontSize || 80
    ctx.font = `${defaultFontSize}px AlexBrush`
    const textMetrics = ctx.measureText(text)
    const textWidth = textMetrics.width
    const paddingRatio = text.length < 5 ? 0.6 : text.length < 10 ? 0.3 : 0.15
    const dynamicWidth = textWidth * (1 + paddingRatio)
    const defaultConfig = {
        width: dynamicWidth,
        height: 150,
        color: "#000",
        fontSize: defaultFontSize
    }
    const config = {...defaultConfig, ...configData}
    const canvasElement = document.createElement("canvas")
    canvasElement.width = config.width
    canvasElement.height = config.height
    const canvas = canvasElement.getContext("2d")
    canvas.fillStyle = config.color
    canvas.textAlign = "center"
    canvas.textBaseline = "middle"
    canvas.font = `${config.fontSize}px AlexBrush`
    canvas.fillText(text, canvasElement.width / 2, canvasElement.height / 2)
    return canvas.canvas.toDataURL()
}

export const getPreviewUnavailableImage = (slug) => {
    return slug === "ogleschool" ? "/image/preview_unavailable_ogle.png" : "/image/preview_unavailable.png"
}

export const onErrorImageLoad = (slug, {currentTarget}) => {
    currentTarget.onError = null
    currentTarget.onerror = null
    currentTarget.src = getPreviewUnavailableImage(slug)
}

export function convertImgToBase64(url): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
            // wait 2 seconds to simulate loading time
            setTimeout(() => {
                let canvas = document.createElement("canvas")
                const ctx = canvas.getContext("2d")
                canvas.height = img.height
                canvas.width = img.width
                ctx.drawImage(img, 0, 0)
                const dataURL = canvas.toDataURL()
                canvas = null
                resolve(dataURL)
            }, 2000)
        }
        img.onerror = (err) => {
            reject(err)
        }
        img.setAttribute("crossOrigin", "anonymous")
        img.src = url
    })
}

export function loadImage(imageObj, key = "url") {
    return new Promise((resolve, reject) => {
        const loadImg = new Image()
        loadImg.src = imageObj[key]
        // wait 2 seconds to simulate loading time
        loadImg.onload = () =>
            setTimeout(() => {
                resolve(imageObj[key])
            }, 2000)

        loadImg.onerror = (err) => {
            reject(err)
        }
    })
}

export async function downloadPDF(dataResponse, name) {
    const file = new Blob([dataResponse], {type: "application/pdf"})
    const fileURL = URL.createObjectURL(file)
    const downloadLink = document.createElement("a")
    const fileName = `${new Date().valueOf()}_${name}.pdf`
    downloadLink.href = fileURL
    downloadLink.download = fileName
    downloadLink.click()
}

export async function downloadLink(url: string) {
    const fileName = (url.match(/^\w+:(\/+([^/#?\s]+)){2,}/) || [])[2] || ""
    const downloadLink = document.createElement("a")
    downloadLink.href = url
    downloadLink.target = "_blank"
    downloadLink.rel = "noopener noreferrer"
    downloadLink.download = fileName
    downloadLink.click()
}

export const downloadFile = (fileName: string, data: string): void => {
    const elDownload = document.createElement("a")
    elDownload.download = fileName
    elDownload.href = URL.createObjectURL(new Blob([data]))
    document.body.appendChild(elDownload)
    elDownload.click()
    document.body.removeChild(elDownload)
}

export const openLinkInNewTab = (url: string): void => {
    const link = document.createElement("a")
    link.setAttribute("href", url)
    link.setAttribute("target", "_blank")
    link.setAttribute("rel", "noopener")
    link.style.visibility = "hidden"

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const getFileExtension = (fileName: string) => {
    return fileName.split(".").pop()
}

export const downloadFileFromUrl = (fileUrl: string, filename: string) => {
    fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement("a")
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        })
        .catch((err) => {
            console.error("Download failed:", err)
        })
}

export const downloadLinkWithName = async (url, filename) => {
    const res = await fetch(url)
    if (!res.ok) console.error("Failed to fetch file")
    const blob = await res.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = blobUrl
    link.download = filename
    link.click()
    window.URL.revokeObjectURL(blobUrl)
}
